import * as actions from './slice'

export const getReportTemplateList = {
  eventName: 'Report Template List Was Requested',
  onSuccess: [{ redux: true, action: actions.setReportkeyList }]
}

